import { FC } from 'react';
import MainLayout from 'components/main-layout/MainLayout';
import CreateForm from './CreateForm';

interface IProps {
  segmentsEntityName: string;
}

const Create: FC<IProps> = ({ segmentsEntityName }) => {
  return (
    <MainLayout title="Добавяне на сегмент">
      <CreateForm segmentsEntityName={segmentsEntityName} />
    </MainLayout>
  );
};

export default Create;
